

import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Intro from './sections/intro/Intro'
import Playlists from './sections/playlists/Playlists'
import Fingerprint2 from 'fingerprintjs2'
import Schedule from './sections/schedule/Schedule'
import Restrictions from './sections/restrictions/Restrictions'
import Button from '../../components/Button'
import Snackbar from 'material-ui/Snackbar'

import './Home.css'

class Home extends Component {

  constructor(props) {
    super(props)
    this.state = {
      device: { name: 'title' },
      open: false,
      loading: false,
      snackMessage: ''
    }
  }

  userWasRecommended = async (referralId, browserId) => {
    let request = await fetch(`https://papirodev.appspot.com/_ah/api/report/recommendation?referralId=${referralId}&browserId=${browserId}`, { method: 'post' })
    let result = await request.json()
  }

  componentDidMount = () => {
    const paramsString = this.props.location.search
    const params = new URLSearchParams(paramsString)
    const referralId = params.get('referralId')

    if (referralId) {
      window.ga('send', { hitType: 'referred', eventCategory: "page", eventAction: 'enter', eventLabel: referralId });
      new Fingerprint2().get(function (result, components) {
        this.userWasRecommended(referralId, result);
      }.bind(this));

    }
  }

  createPlayer = async () => {
    let info = {};
    let selectedPlaylists = [];
    this.state.device.playlists.objects.filter((element) => element.selected).forEach((element) => selectedPlaylists.push(element.dbid));
    if (selectedPlaylists.length === 0) {
      this.setState({
        open: true,
        snackMessage: 'Debes seleccionar al menos un playlist para continuar'
      });
      return
    }
    this.setState({ loading: true })
    let playerInfo = { playlists: selectedPlaylists };
    playerInfo.isLicenseActive = document.isLicenseActive;
    playerInfo.comercialName = document.companyName;
    playerInfo.patentName = document.patentName;
    playerInfo.address = document.address;
    playerInfo.phonenumber = document.phonenumber;
    playerInfo.email = document.email;
    playerInfo.licenseType = document.licenseType;    
    let request = await fetch(`https://papirodev.appspot.com/_ah/api/api/v2/devices/new?alt=json`,
      {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(playerInfo)
      })
    let device = await request.json()
    window.ga('send', { hitType: 'event', eventCategory: "freemium", eventAction: 'create-player', eventLabel: device.publicAccessCode });
    this.props.history.push(`/player/${device.code}?publicCode=${device.publicAccessCode}`);
  }

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  playlistsChanged = () => {
    this.setState({});
  }

  forBusinessLicense = () => {
    this.props.history.push(`/quotation`);
  };

  forBusinessClicked = () => {
    window.ga('send', { hitType: 'event', eventCategory: "freemium", eventAction: 'for-bussiness', eventLabel: 'go' })
    return true
  }

  render() {
    return (
      <div className="home-page">
        {this.state.loading ? (<div className="loading-page">
          <div className="loading-page-content" style={this.state.loadingStyle}>
            <h1 className="loading-text">Cargando...</h1>
            {this.state.deviceCode ?
              <div className="player-help">
                <div className="player-help-description">ponmusica.com</div>
                <div className="player-help-code-container">Código: <br /><span className="player-help-code">{this.state.deviceCode}</span></div>
              </div> : null}
          </div>
        </div>) : (
            <div>
              <div className="home">
                <Intro />
                <Playlists device={this.state.device} playlistsChangedListener={this.playlistsChanged} />
                <section className="confirmation">
                  <br />
                  <br />
                  <Button className="tempo-button btn-start" onClick={() => this.createPlayer()}>
                    Iniciar rockola
                  </Button>
                </section>
              </div>
              <Snackbar
                open={this.state.open}
                message={this.state.snackMessage}
                autoHideDuration={4000}
                onRequestClose={this.handleRequestClose}
              />
              <br />
              <br />
              <section className="bottom">
                <div className="bottom-content">
                  <span>Powered by <a className="powered-by" href="http://www.adstter.com">Adstter</a></span>
                </div>
                <span className="for-business"><a href="http://www.adstter.com/tempo/" onClick={this.forBusinessClicked}>Para negocios</a></span>
              </section>
            </div>)}
      </div>
    )
  }
}

export default withRouter(Home)



// WEBPACK FOOTER //
// ./src/pages/home/Home.js